import React from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../../../utils/date";
import { Income } from "../../../../types/income";
import { Button } from "../../../ui-kit/Button";
import { Spinner } from "../../../ui-kit/Spinner";
import { PartnerIconCell } from "../../Receipt/components/ReceiptTable/Cells/PartnerIconCell";
import {
  FooterItem,
  FooterLabel,
  FooterValue,
  List,
  ListDate,
  ListFooter,
  ListItem,
  ListSeller,
  ListSellerText,
  LoadMore,
  LoadingContainer,
  NoData,
  SellerName,
  SellerTin,
} from "./styled";

function sellerIcon(tin?: string) {
  if (tin === "") return "/images/markets/lotery-default.png";
  
  return "none";
}

function formatMoney(value: number, empty: string) {
  return value
    ? Math.floor(value / 100).toLocaleString("ru-RU", {
        maximumFractionDigits: 0,
      })
    : empty;
}

export function IncomeList({
  data,
  loading,
  hasMore,
  onLoadMore,
}: {
  data: Income[];
  loading: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
}) {
  const { t } = useTranslation();

  return (
    <List>
      {data.map((item, index) => (
        <ListItem key={`${item.date}-${item.tin}-${item.amount}-${index}`}>
          <ListDate>
            {formatDate(new Date(item.date), "dd.MM.yyyy HH:mm")}
          </ListDate>
          <ListSeller>
            <PartnerIconCell value={sellerIcon(item.tin)} />
            <ListSellerText>
              <SellerName>{item.seller}</SellerName>
              {item.tin ? (
                <SellerTin>
                  {t("ИНН продавца")} {item.tin}
                </SellerTin>
              ) : null}
            </ListSellerText>
          </ListSeller>
          <ListFooter>
            <FooterItem>
              <FooterValue>{formatMoney(item.receiptSum, "-")}</FooterValue>
              <FooterLabel>{t("Стоимость")}</FooterLabel>
            </FooterItem>
            <FooterItem>
              <FooterValue>{formatMoney(item.amount, "0.00")}</FooterValue>
              <FooterLabel>{t("Вычет")}</FooterLabel>
            </FooterItem>
          </ListFooter>
        </ListItem>
      ))}

      {hasMore && (
        <LoadMore>
          <Button onClick={onLoadMore}>{t("Показать еще")}</Button>
        </LoadMore>
      )}
      {!data.length && !loading && <NoData>{t("Нет данных")}</NoData>}
      {loading && (
        <LoadingContainer>
          <Spinner radius="20px" />
        </LoadingContainer>
      )}
    </List>
  );
}
